module.exports = __webpack_public_path__ + "static/img/case_detail_10_1.1e5c107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_10_1.png
// module id = Nnvt
// module chunks = 34